module.exports = __webpack_public_path__ + "static/media/bunny_2.8aaa3654.jpg";